import { CheckBox } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useState } from "react";
import { data } from "./constants";
import {
  ButtonContainer,
  ButtonDescription,
  ButtonLine,
  Container,
  ContentContainer,
  ItemsContainer,
  Title,
  ChecklistGrid,
  ChecklistItem,
} from "./style";

export default function CleaningChecklist() {
  // Auto-select first tab (Kitchen)
  const [value, setValue] = useState(0);

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  if (!data) return null;

  return (
    <Container>
      <Title>Cleaning Checklist</Title>

      <ButtonContainer>
        {data.map((types, index) => (
          <ButtonLine
            key={index}
            isActive={index === value}
            onClick={() => handleChange(index)}
          >
            <ButtonDescription>{types.title}</ButtonDescription>
          </ButtonLine>
        ))}
      </ButtonContainer>

      <ContentContainer>
        <ItemsContainer>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              padding: "20px",
            }}
          >
            <h2 style={{ color: "#4a7094", textAlign: "center", width: "100%", margin: "0" }}>{data[value].title}</h2>
            <ChecklistGrid>
              {data[value].items.map((text, i) => (
                <ChecklistItem key={i}>
                  <CheckBox sx={{ color: "#4a7094" }} />
                  {text}
                </ChecklistItem>
              ))}
            </ChecklistGrid>
          </Box>
        </ItemsContainer>
      </ContentContainer>
    </Container>
  );
}
